import { BANK_OPTIONS } from '@/constant/bank-options'

export const getBankLabel = (bankName?: string) => {
  if (!bankName) return '-'
  const bank = BANK_OPTIONS.find((b) => b.value === bankName)
  return bank ? bank.label : bankName || '-'
}
